<template>
  <a-modal title="调整积分"
           :open="modal"
           :confirm-loading="loading"
           :mask-closable="false"
           ok-text="保存" @ok="okCk"
           cancel-text="关闭" @cancel="cancelCk">
    <a-form ref="form"
            size="small"
            :model="entity"
            :rules="rules"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 20 }">
      <a-form-item label="数量" name="num">
        <a-input-number v-model:value="entity.num"/>
      </a-form-item>

      <a-form-item label="订单ID" name="orderId">
        <a-input-number v-model:value="entity.orderId"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'
import {message} from 'ant-design-vue'

const emits = defineEmits(['refresh'])

const modal = ref(false)
const loading = ref(false)
const form = ref(null)
const entity = ref({})

let rate = 0

const rules = {
  num: [{
    required: true,
    message: '数量不能为空',
    trigger: 'blur'
  }],
  orderId: [{
    required: true,
    message: '订单ID不能为空',
    trigger: 'blur'
  }],
}

let userId, typeId

function openCk(id, type) {
  userId = id
  typeId = type
  axios.get('/config/order_point_rate', {
    params: {
      type: 'int'
    }
  }).then((res) => {
    if (res.code === 1) {
      rate = res.data
    }
    modal.value = true
  })
}

function okCk() {
  loading.value = true

  form.value.validate().then(() => {
    axios.post(`/user/${userId}/order-point`, {
      typeId: typeId,
      orderId: entity.value.orderId,
      num: entity.value.num * rate,
    }).then((res) => {
      loading.value = false

      if (res.code === 1) {
        message.success('操作成功')
        emits('refresh')
        modal.value = false
        form.value.resetFields()
      }
    })
  }).catch(() => {
    loading.value = false
  })
}

function cancelCk() {
  modal.value = false
  form.value.resetFields()
  loading.value = false
}

defineExpose({openCk})
</script>
